<div class="tw-dialog">

  <!-- Header -->
  <div class="tw-header">
    <div class="tw-title-wrap">
      <div class="tw-title-icon">
        <mat-icon>delete_outline</mat-icon>
      </div>
      <div class="tw-title-text">
        <h2 class="tw-title">Delete templates &amp; workflows</h2>
        <div class="tw-subtitle">Select what to remove — this can't be undone</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="tw-close" [disabled]="deleting" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <form id="templateWorkflowDelete" class="tw-body" (ngSubmit)="deleteClick()">

    <!-- Templates -->
    <section class="tw-col">
      <div class="tw-col-head">
        <span class="tw-col-title">
          <mat-icon>local_florist</mat-icon> Templates
        </span>
        <span class="tw-count" [class.on]="primaryTemplates.length > 0">{{primaryTemplates.length}} selected</span>
      </div>

      <app-template-select-multiple
        class="tw-picker"
        [displayFor]="'templates'"
        [(selectedPrimaryTemplates)]="primaryTemplates">
      </app-template-select-multiple>

      <div class="tw-list">
        @if (primaryTemplates.length === 0) {
          <div class="tw-empty">
            <mat-icon>inbox</mat-icon>
            No templates selected
          </div>
        } @else {
          @for (template of primaryTemplates; track template) {
            <div class="tw-row">
              <mat-icon class="tw-row-icon">description</mat-icon>
              <span class="tw-row-name">{{template.name}}</span>
            </div>
          }
        }
      </div>
    </section>

    <!-- Workflows -->
    <section class="tw-col">
      <div class="tw-col-head">
        <span class="tw-col-title">
          <mat-icon>account_tree</mat-icon> Workflows
        </span>
        <span class="tw-count" [class.on]="secondaryTemplates.length > 0">{{secondaryTemplates.length}} selected</span>
      </div>

      <app-template-select-multiple
        class="tw-picker"
        [displayFor]="'workflows'"
        [(selectedSecondaryTemplates)]="secondaryTemplates">
      </app-template-select-multiple>

      <div class="tw-list">
        @if (secondaryTemplates.length === 0) {
          <div class="tw-empty">
            <mat-icon>inbox</mat-icon>
            No workflows selected
          </div>
        } @else {
          @for (workflow of secondaryTemplates; track workflow) {
            <div class="tw-row">
              <mat-icon class="tw-row-icon">account_tree</mat-icon>
              <span class="tw-row-name">{{workflow.name}}</span>
            </div>
          }
        }
      </div>
    </section>

  </form>

  <!-- Footer -->
  <div class="tw-footer">
    <span class="tw-footer-note">
      <mat-icon>warning_amber</mat-icon>
      @if (totalSelected > 0) {
        {{totalSelected}} item{{totalSelected === 1 ? '' : 's'}} will be permanently deleted.
      } @else {
        Deleting is permanent and can't be undone.
      }
    </span>
    <div class="tw-footer-actions">
      <button mat-button mat-dialog-close class="tw-btn-ghost" [disabled]="deleting">Cancel</button>
      <button type="submit" form="templateWorkflowDelete" class="tw-btn-danger" [disabled]="deleting || totalSelected === 0">
        @if (deleting) {
          <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        } @else {
          <mat-icon>delete</mat-icon>
          <span>Delete{{totalSelected > 0 ? ' ' + totalSelected : ''}}</span>
        }
      </button>
    </div>
  </div>

</div>
